import { useMemo } from "react";

import { AutoComplete } from "@/components/AutoCompleteInput";

interface ExpectedToolsInputProps {
  value: string[];
  onChange: (tools: string[]) => void;
  suggestions: string[];
  hasTraceSource: boolean;
  disabled?: boolean;
  showHelperText?: boolean;
}

export const ExpectedToolsInput = ({
  value,
  onChange,
  suggestions,
  hasTraceSource,
  disabled = false,
  showHelperText = true,
}: ExpectedToolsInputProps) => {
  const selectedTools = value;

  const options = useMemo(() => {
    const suggestionOptions = suggestions.map(tool => ({
      id: tool,
      value: tool,
      label: tool,
    }));
    const missingSelected = selectedTools
      .filter(tool => !suggestions.includes(tool))
      .map(tool => ({
        id: tool,
        value: tool,
        label: tool,
      }));
    return [...suggestionOptions, ...missingSelected];
  }, [selectedTools, suggestions]);

  let helperText = "Select an Agent Trace column to suggest tools from existing rows.";
  if (hasTraceSource && suggestions.length > 0) {
    helperText = "Suggestions come from tools found in the selected Agent Trace column.";
  } else if (hasTraceSource) {
    helperText =
      "No tools found in the selected Agent Trace column yet. Type a tool name to add it.";
  }

  return (
    <div className="w-full min-w-0 space-y-1.5">
      <AutoComplete
        multi
        options={options}
        selectedValues={selectedTools}
        onSelectionChange={onChange}
        placeholder="Search or add tools..."
        addNewOption
        getAddOptionText={query => `Add "${query}"`}
        isDisabled={disabled}
        maxVisibleTags={1}
        popoverMinWidth={240}
        className="w-full"
      />
      {showHelperText ? <p className="text-xs text-muted-foreground">{helperText}</p> : null}
    </div>
  );
};
